import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';

export const SUBMIT_KAPITI_TRANSACTIONS_REQUEST = 'SUBMIT_KAPITI_TRANSACTIONS_REQUEST';
export const SUBMIT_KAPITI_TRANSACTIONS_SUCCESS = 'SUBMIT_KAPITI_TRANSACTIONS_SUCCESS';
export const SUBMIT_KAPITI_TRANSACTIONS_FAILURE = 'SUBMIT_KAPITI_TRANSACTIONS_FAILURE';

export const fetchKapitiTransactions = (appTitle, bankId, accountId) => {
	const body = JSON.stringify({ bank_id: bankId, account_uuid: accountId, app_title: appTitle });
	const endpoint = endpoints.kapitiTransactions;
	const action = {
		[RSAA]: {
			endpoint: endpoint.uri,
			method: endpoint.method,
			types: [
				SUBMIT_KAPITI_TRANSACTIONS_REQUEST,
				SUBMIT_KAPITI_TRANSACTIONS_SUCCESS,
				SUBMIT_KAPITI_TRANSACTIONS_FAILURE,
			],
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
			body,
		},
	};

	return action;
};
